import { Component, Inject, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ObjectUtil } from '../../utils/object-util';
import { environment } from 'src/environments/environment.staging';
import { ToastMessageComponent } from '../toast-message/toast-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SiteService } from '../../services/site.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-add-point-model',
  templateUrl: './add-point-model.component.html',
  styleUrls: ['./add-point-model.component.scss'],
  standalone: false
})
export class AddPointModelComponent implements OnInit {

isGraphicsBuilderTypeChanged: boolean = false;
showscopeChangeWarning: boolean = false;
showTagTooltip: boolean = false;
hasError: boolean = false;
callMade: boolean = false;
fetchingPoints: boolean = false;
hasChanges: boolean = false;
hoverActive: boolean = false;
isLoading: boolean = false;
graphicsApiCallInitiated: boolean = false;

numResults: number = 0;
tooltipPos: number = 0;
hoveredIndex: number = 0;

builderType: string = 'BUILDER';
haystackQuery: string = '';
warningMsg: string = '';
emptyLabel: string = '';
errMsg: string = '';

selectedTags: string[] = [];
tagList: string[] = [];

tempscope: any = {};

points: any = [];
pointsCopy: any[] = [];
query: any;

buildTypeOptions: {label: string, value: string}[] = [
  {
    label: 'BUILDER',
    value: 'BUILDER'
  },
  {
    label: 'CUSTOM',
    value: 'CUSTOM'
  }
];
loggedInUser: any;

// Subscriptions
subscriptions: any = {};
kVTags:any = [];
tagsType = [];

@ViewChildren('tagSelectGraphics') tagSelectGraphics!: NgSelectComponent;

  regionId: string = '';
  tagValuesMap = {};

  get isEditMode(): boolean {
    return !!this.data?.isEditMode;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddPointModelComponent>,
    public dialog: MatDialog,
    private toastMessage: MatSnackBar,
    private siloService: SiteService
  ) { 
    }

  async ngOnInit(): Promise<void> {
    this.regionId = this.data?.regionId;
    this.builderType = this.data?.builderType || 'BUILDER';
    this.selectedTags = this.data?.selectedTags || [];
    this.haystackQuery = this.data?.haystackQuery || '';
    this.tagValuesMap = this.data?.tagValuesMap || {};
    this.kVTags = this.data?.kVTags || [];
    if (!Object.keys(this.tagValuesMap).length && Array.isArray(this.kVTags) && this.kVTags.length) {
      this.tagValuesMap = this.kVTags.reduce((acc: any, tag: any) => {
        if (tag?.key) {
          acc[tag.key] = tag;
        }
        return acc;
      }, {});
    }
    this.createGraphicsFormGroup();
    if (this.builderType === 'CUSTOM' && this.haystackQuery) {
      this.executeCustomQuery(this.haystackQuery);
    }
  }

  
  async createGraphicsFormGroup() {
  
    setTimeout(() => {
      this.onInputBlur();
    });
    this.getTags();
  }


  /**
   * Handles the selection of a build type from a menu option.
   * If the selected build type is different from the current builder type and buildscope is false,
   * a scope change warning is shown and the temporary scope is set to the selected build type option.
   * Otherwise, updates the builder type, form control value, and resets relevant properties.
   */
  onBuildTypeSelect(event: { label: string, value: string }, buildscope = false) {
    if (this.builderType == event.value) return;
    if (this.builderType && this.builderType !== event.value && !buildscope) {
      this.showscopeChangeWarning = true;
      this.tempscope = this.buildTypeOptions.find(option => option.value === event.value);
      return;
    }
    this.builderType = event.label;
    this.showscopeChangeWarning = false;
    this.selectedTags = [];
    this.haystackQuery = '';
    this.tagValuesMap = {};
    this.onTagsClear()
  }

  // Clears the selected tags, points, and warning message.
  onTagsClear() {
    this.selectedTags = [];
    this.points = [];
    this.kVTags = [];
    this.warningMsg = '';
    this.haystackQuery = '';
    this.tagValuesMap = {};
  }

  // Clears the points array
  onCustomHaystackQueryEdited() {
    this.points = [];
  }

  /**
   * Resets the sidebar by clearing the points and selected tags.
   */
  resetSideBar() {
    this.points = [];
    this.selectedTags = [];
    this.tagValuesMap = {};
  }

  /**
   * Handles the focus event on an input element.
   */
  onInputFocus() {
    setTimeout(() => {
      let parentEle = document.getElementsByClassName("ng-value-container")[0];
      parentEle.scrollLeft = parentEle?.scrollWidth;
    });
  }

  // Handles the blur event on an input element in ng-select.
  onInputBlur() {
    setTimeout(() => {
      this.updateNgSelectPlaceholderPos();
    });
  };

  // Handles the de-selection of a tag from the ng-select dropdown.
  onTagDeSelect(item: any) {
    this.selectedTags = this.selectedTags.filter((_item) => _item !== item);
    if (this.selectedTags.length === 0) {
      this.points = [];
      this.haystackQuery = '';
      this.tagValuesMap = {}; // Clear the tag values map when all tags are deselected
    }
    const preSelectedKvTags: { [key: string]: any } = this.tagValuesMap || {};
    if (preSelectedKvTags?.[item]) {
      delete preSelectedKvTags[item];
      this.tagValuesMap = { ...preSelectedKvTags };
    }
  }

  // Handles the selection of a tag from the ng-select dropdown.
  onTagsChange(tags: string[]) {
    if(!tags.length) return;
    if (this.builderType != 'CUSTOM') {
     
      const tagValuesMap: { [key: string]: any } = this.tagValuesMap ?? {};
      let kvTags = this.generateKvTagsList(tags, this.tagsType);
      if (Object.keys(tagValuesMap).length) {
        kvTags = kvTags.map(tag => {
          if (tagValuesMap[tag.key]) {
            tag['value'] = tagValuesMap[tag.key].value;
          }
          return tag;
        });
      }
      this.kVTags = ObjectUtil.deepClone(kvTags);
    }
    let query = this.generateQueryWithTags(tags);
    this.haystackQuery = query;
    this.getPointsFromSide(`(${query}) and siteRef==@${this.data.siteId})`);
    setTimeout(() => {
      (this.tagSelectGraphics as any)?.first?.element?.querySelector('input')?.focus();
    }, 100);
  }

  markFirst() {
    return this.numResults === 0;
  }

  /**
   * Handles the mouse out event for a point, hiding the tag and tooltip.
   */
  pointHoverMouseOut(point: any) {
    point.showTag = false
    this.showTagTooltip = false
  }

  /**
   * Handles the hover event on a point and displays a tooltip.
   */
  pointHover(event: any, point: any) {
    point.showTag = true
    setTimeout(() => {
      this.showTagTooltip = true
    }, 20);
    let y = event.y
    let len = point?.tags?.length
    if (len < 20) {
      this.tooltipPos = y - 155
    } else {
      this.tooltipPos = y - 168
    }
  }

  /**
   * Returns an object representing the CSS style for the tooltip position.
   */
  toolTipPosition() {
    return {
      'top': `${this.tooltipPos}px`
    };
  }

  /**
   * Executes a custom query and processes the result.
   */
  executeCustomQuery(query:string) {
    if (this.fetchingPoints) {
      return;
    }
    this.hasError = false;
    this.query = this.processCustomQuery(query);
    
    this.getPointsFromSide(this.query);
    this.hasChanges = true;
  }

  /**
   * Processes a custom query by appending a site reference part and ensuring it contains a specific substring.
   */
  processCustomQuery(query: string) {
    let processedQuery;
    const siteRefPart = `siteRef==@${this.data.siteId}`;
    processedQuery = `${siteRefPart} and (${query})`;
    return processedQuery;
  }

  /**
   * Generates a query string with the provided tags.
   * This method constructs a query string based on the `siteId` from `this.data`
   * and the provided tags. It ensures that the query string includes a reference
   * to the site and any additional tags specified.
   */
  generateQueryWithTags(tags: string[]) {
    let query = null;
    query = ``;
    const queryTags = new Set();
    if (tags && Array.isArray(tags) && tags.length) {
      tags.forEach(tag => {
        if (!this.kVTags.some((_tag: any) => _tag.key === tag)) {
          queryTags.add(tag);
        }
      });
    }
    if (queryTags.size > 0) {
      if (queryTags) {
        query += `${[...queryTags].join(' and ')}`
      }
    }

    if (this.kVTags?.length) {
      const queryWithKvTagsValues = `${query ? ' and ':''}${this.generateQueryFromKvTags(this.kVTags)}`;
      query += `${queryWithKvTagsValues}`;
    }
    this.query = query;
    return query;
  }

  /**
   * Fetches points from the API based on the provided query and updates the component state.
   */
  getPointsFromSide(query:string) {
    this.fetchingPoints = true;
    this.getPointsForBuilder(query, this.data?.siteName).subscribe({
      next: ({ points }) => {
        this.fetchingPoints = false;
        this.points = points;
        this.pointsCopy = points;
        if (!this.points?.length) {
          this.emptyLabel = 'NA';
        } else {
          this.emptyLabel = '';
        }
        this.callMade = true;
      }, error: () => {
        this.points = [];
        this.emptyLabel = 'NA';
        this.hasError = true;
        this.errMsg = 'There was an error in executing the Query !';
        this.fetchingPoints = false;
      }
    });
  }

  // Function to get list of Tags with selected site
  getTags() {
    this.siloService.getmultiSiteTags([this.data.siteId])
      .subscribe(({ rows }) => {
        this.tagList = Array.from(new Set(rows[0]?.tags));
        this.tagsType = rows[0]?.tagTypes;
        this.isLoading = false;
        if (this.builderType === 'BUILDER' && this.selectedTags?.length) {
          this.onTagsChange([...this.selectedTags]);
        }
      }, (err: any) => {

        this.showToast('error', 'Something went wrong, please try again');
      });
  }

  showToast(type: string, message: string) {
    this.toastMessage.openFromComponent(ToastMessageComponent, {
      duration: 5000,
      data: {
        type: type,
        message: message
      },
    });
  }


  // To close modal dialog
  cancelDialog() {
    this.dialogRef.close();
  }


  // Handles the hover event for a specific item.
  onHover(i: number) {
    this.hoveredIndex = i;
    this.hoverActive = true;
  }

  // Handles the mouse out event for a specific item.
  onMouseOut() {
    this.hoverActive = false;
  }

  formatName(name: string): string {
    return this.formatDABProfileName(name);
  }

  setTagValue(event: Event, tag: any) {
    const inputElement = event.target as HTMLInputElement;
    tag.value = inputElement.value;
    const preSelectedKvTags = this.tagValuesMap|| {};
    this.tagValuesMap = { ...preSelectedKvTags, [tag.key]: tag };
  }

  onTagMenuClose() {
    this.onTagsChange([...this.selectedTags]);
  }

  formatDABProfileName(nameLabel: string): string {
    if (!nameLabel) {
      return '';
    }
    const isCarrier = environment.productName.toLocaleLowerCase() === 'climavision';
    if (!isCarrier) {
      return nameLabel;
    }

    // Match 'dab' (case-insensitive) when at start or preceded by non-letter/number, and followed by letter/number
    return nameLabel.replace(/(^|[^a-zA-Z0-9])dab/gi, (match, p1) => {
      return p1 + 'VVT-C';
    });
  }

  updateNgSelectPlaceholderPos() {
    let parentEle = document.getElementsByClassName("ng-value-container")[0];
    if (!parentEle) return;
    let childEle = parentEle.querySelector(".ng-placeholder") as HTMLElement;
    let childEle1 = parentEle.querySelector(".ng-input") as HTMLElement;
    const hasValues = parentEle.querySelectorAll(".ng-value").length > 0;

    // Recreate placeholder if it's not there in DOM
    if (hasValues) {
      if (!childEle) {
        childEle = document.createElement("div");
        childEle.className = "ng-placeholder dynamic-ng-placeholder";
      }
      parentEle.insertBefore(childEle, childEle1);
      parentEle.scrollLeft = parentEle.scrollWidth;
    } else {
      // If no items selected, remove dynamic placeholder only
      const dynamicPlaceholder = parentEle.querySelector(".ng-placeholder.dynamic-ng-placeholder") as HTMLElement;
      dynamicPlaceholder?.remove();
    }
  }

  generateQueryFromKvTags(kvTags: any[]): string {
        let query = ``;
        kvTags.forEach(tag => {
            if (tag.value) {
                const values = tag.value.trim().split(',').map((value: string) => value.trim()).filter((value: string) => value !== '');
                if (values.length) {
                    const conditions = values.map((value: string) => {
                        if (tag.type === 'HaystackRef') {
                            return `${tag.key} == @${value}`;
                        } else if (tag.type === 'HaystackStr') {
                            return `${tag.key} == \\"${value}\\"`;
                        } else {
                            return `${tag.key} == ${value}`;
                        }
                    });
                    query += ` (${conditions.join(' or ')})`;
                }
            } else {
                query += ` ${tag.key}`;
            }
            if (kvTags.indexOf(tag) !== kvTags.length - 1) {
                query += ' and';
            }
        });

        return query;
    }

    generateKvTagsList(tags: string[], tagsType: any[]): any[] {
        const kvTags: any[] = [];
        tags.forEach(tag => {
            let tagObj: any = {
                key: tag,
                value: '',
                type: tagsType?.find(type => type.name == tag)?.type
            }
            kvTags.push(tagObj);
        });
        return kvTags.filter(tag => tag.type != 'HaystackMarker');
    }

    getPointsForBuilder(query: string, siteName: string): Observable<any> {
    // Initialize necessary variables (could be handled inside a component or state management)
    let points:any = [];

    return this.siloService.findByFilter(query).pipe(
      map(res => {
        // Apply the helper function to strip Haystack type mappings
        const strippedData = this.siloService.stripHaystackTypeMapping(res);

        // Process incoming points
        points = strippedData.rows?.map((_item: any) => {
          _item['displayName'] = _item.dis.includes(siteName) ? _item.dis.replace(siteName + '-', '') : _item.dis;
          _item['tags'] = [];

          Object.keys(_item).forEach(point => {
            if (point != 'tags' && point != 'originalName' && point != 'pointId' && point != 'name' && point != 'displayName') {
              let pointObj = {
                'tagName': point,
                'isQueryTag': query.includes(point)
              };
              _item['tags'].push(pointObj);
            }
          });

          _item['showTag'] = false;
          _item['pointDefTags'] = _item.tags.filter((_r: any) => (_r.tagName != 'pointId' && _r.tagName != 'name' && _r.tagName != 'displayName')).map((item: any) => item.tagName);
         
          return _item;
        });

        // Ascending order by point name
        points = points?.sort((point1: any, point2: any) => point1?.displayName.localeCompare(point2?.displayName));

        return { points };
      })
    );
  }

  searchTag(searchTerm: string, tag: any) {
    searchTerm = searchTerm?.toLowerCase();
    tag = tag?.toLowerCase();
    if (searchTerm.startsWith('!')) {
      if (tag.startsWith(searchTerm.slice(1))) {
        return true;
      }
      return false;
    }
    else {
      if (tag.toLowerCase().startsWith(searchTerm)) {
        return true;
      }
      return false;
    }
  }

  addQuery() {
    this.dialogRef.close({
      haystackQuery: this.haystackQuery,
      builderType: this.builderType,
      selectedTags: this.selectedTags,
      tagValuesMap: this.tagValuesMap,
      kVTags: this.kVTags
    });
  }


}
